export const statusCode = {
  success: 0,
  tooManyLoads: 1,
};
